module.exports = __webpack_public_path__ + "img/zhengchang.a9389547.png";